export enum TransactionActionTypes {
  GetTransactionsLocal = 'GetTransactionsLocal',
  SetTransaction = 'SetTransaction',
  DeleteTransaction = 'DeleteTransaction',
}
